import React from 'react';

export function CloseButton({ onClick, className }) {
  return (
    <button
      type="button"
      className={`flex items-center justify-center p-2 w-[37px] h-[37px] bg-[#f5f5f5] hover:bg-[#e5e5e5] transition rounded-full ${className}`}
      onClick={onClick}
    >
      <img src="/times.png" alt="item header" className="img-fluid" />
    </button>
  );
}
